/**
 * Marker w odpowiedzi Gemmy: UI usuwa go z tekstu i pokazuje przycisk dodania PDF pod KZM
 * (drawer AIDialog + czat wewnętrzny).
 */
export const GEMMA_INLINE_KZM_PDF_MARKER = '[[unitresco:attach_kzm_pdf]]';

export function stripGemmaInlineKzmPdfMarker(text: string): { displayText: string; showInlinePdfAttach: boolean } {
  const showInlinePdfAttach = text.includes(GEMMA_INLINE_KZM_PDF_MARKER);
  const displayText = text
    .split(GEMMA_INLINE_KZM_PDF_MARKER).join('')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/[ \t]+\n/g, '\n')
    .trimEnd();
  return { displayText, showInlinePdfAttach };
}
